// extracted by mini-css-extract-plugin
module.exports = {"container":"_1R1CaBLJDldnwv8p69qgll","newDishModificationFields":"_2Ce9VL5gfDiZ_5DOPJSQWk"};